export enum StepStatus {
  Completed = 'completed',
  Active = 'active',
  Inactive = 'inactive'
}
